export const ORDER_DROPDOWN_OPTIONS = [
    {
        id: '1',
        text: 'Select'
    },
    {
        id: '2',
        text: 'Select All'
    },
    {
        id: '3',
        text: 'Sort from old to new'
    },
    {
        id: '4',
        text: 'Sort from new to old'
    },
];
export const SORT_TYPES = {
    OLD_TO_NEW: 'oldToNew',
    NEW_TO_OLD: 'newToOld'
};
//# sourceMappingURL=index.js.map